import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  capturing: false,
  pollingInterval: 10000,
  loading: false,
  pending: false,
  error: false,
};

const recognitionSlicer = createSlice({
  name: 'recognition',
  initialState,
  reducers: {
    setCapturing: (state, action) => {
      state.capturing = action.payload;
    },
    setPollingInterval: (state, action) => {
      state.pollingInterval = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPending: (state, action) => {
      state.pending = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { actions } = recognitionSlicer;

export default recognitionSlicer.reducer;
